import authService from "~/services/authService";
import { Firebase } from "./firebase";
import { RecaptchaVerifier, signInWithPhoneNumber,
	createUserWithEmailAndPassword, sendEmailVerification,
	signInWithEmailAndPassword, sendPasswordResetEmail,
	signInWithCustomToken,
	getAuth, } from "firebase/auth";
import api from "~/services/api";
import axios from "axios";
import apiTwilio from "~/services/apiTwilio";

export const getUser = () => {
	return api.get('me');
};

export const sendNumber = (number) => {
	const auth = Firebase;
	if (!number.startsWith('+55') && !number.startsWith('55') && !number.startsWith('+351') && !number.startsWith('351')) {
		auth.languageCode = 'en';
	}
	
	if (!window.recaptchaVerifier) {
		window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
			'size': 'invisible',
			'callback': (response) => {
				console.log("reCAPTCHA resolved");
			},
			'expired-callback': () => {
				console.warn("reCAPTCHA expired. Resetting...");
				window.recaptchaVerifier.reset();
			}
		}, auth);
	}
	let appVerifier = window.recaptchaVerifier;
	return signInWithPhoneNumber(auth, number, appVerifier);
};

export const verifyCode = (getConfirmation, code) => {
	const credential = authService.getCredential(getConfirmation.verificationId, code);
	return authService.authenticateUser(credential);
};

export const sendEmailCreate = (email, password) => {
	const auth = Firebase;
	return createUserWithEmailAndPassword(auth, email, password);
};

export const sendEmailVerify = (user) => {
	return sendEmailVerification(user);
};

export const loginEmail = (email, password) => {
	const auth = Firebase;
	return signInWithEmailAndPassword(auth, email, password);
};

export const forgotPassword = (email) => {
	const auth = Firebase;
	return sendPasswordResetEmail(auth, email);
};

// Login com SMS Twilio

export const sendSmsTwilio = (celphone, isWhatsApp = false) => {
	if (isWhatsApp) {
		return apiTwilio.apiTwilio.post('user/auth/', {
			phone: celphone,
			channel: 'whatsapp',
		});
	}
	return apiTwilio.apiTwilio.post('user/auth/', {
		phone: celphone,
	});
};

export const sendSMSCodeTwilio = (celphone, codeTwilio) => {
	return apiTwilio.apiTwilio.post('user/auth/verify', {
		phone: celphone,
		code: codeTwilio,
	});
};

export const sendTokenFirebase = (token) => {
	const auth = getAuth();
	return  signInWithCustomToken(auth, token);
};

// Login com wavy

export const sendMsgWavy = (celphone) => {
	return apiTwilio.apiTwilio.post('user/auth/wavy', {
		phone: celphone,
	});
};

export const sendMessageWavy = (celphone, codeWhatsApp) => {
	return apiTwilio.apiTwilio.post('user/auth/wavy/verify', {
		phone: celphone,
		code: codeWhatsApp,
	});
};

// Login com código

export const verifyAuthCode = (authCode) => {
	return apiTwilio.apiTwilio.post('auth_link/verify', {
		code: authCode,
	});
};

export const verifyBookingAuthCode = (authCode) => {
	return apiTwilio.apiTwilio.post('auth_link/verify_booking', {
		code: authCode,
	});
};

// Login com link

export const authRenew = (config) => {
	return api.post('user/auth/renew',{}, config);
  };

// Auth with WhatsApp

// context: "booking" (padrão), "login" (ver agendamentos) ou "payment" — define a resposta do WhatsApp
export const authCredential = (language, context = "booking") => {
	let url = `${process.env.REACT_APP_URL_API}auth_credential/login`;

	const payload = {
		language: language || 'pt-BR',
		request_is_from: 'web',
		link_type: 'uri',
		context,
	};

	return axios.post(url, payload, {
		headers: {
			Authorization: `${process.env.REACT_APP_TOKEN_SMS_TWILIO}`,
			"content-type": "application/json",
		}
	});
}

export const verifyAuthCredential = (code) => {
	return axios.post(`${process.env.REACT_APP_URL_API}auth_credential/verify`, {
		code: String(code),
	}, {
		headers: {
			Authorization: `${process.env.REACT_APP_TOKEN_SMS_TWILIO}`,
			"content-type": "application/json",
		}
	});
}
